const gobiDefaultSettings = {
    "class": "gobi-stories",
    "data-gobi-color": "#8E7F6A",
    "data-gobi-bubble-size": "150px",
    "data-gobi-animated-bubble": true,
    "data-gobi-show-play-icon": true,
    "data-gobi-auto-segue": true,
    "data-gobi-title-font-size": "18px",
    "data-gobi-hide-title": true,
    "data-gobi-auto-start-with-sound": true,
    "data-gobi-inherit-text-styles": true,
    "style": "font-family: wfont_f24edf_4ba14c544a5449ebbdb7474dd81778cc,wf_4ba14c544a5449ebbdb7474dd,orig_basic_sans_light"
};

class GobiStoriesContainer extends HTMLElement {

    constructor() {
        super();
        console.log("Constructed GobiStoriesContainer")
        console.log(this);
    }

    connectedCallback() {
        console.log("connectedCallback on GobiStoriesContainer");
        var settings = {};
        var discover = true;
        for (var index = 0; index < this.attributes.length; index++) {
            var attribute = this.attributes.item(index);
            var value = attribute.value;
            if (attribute == "discover") {
                discover = value;
            } else {
                if (attribute.name == "data-gobi-style") {
                    var styles = [
                        gobiDefaultSettings["style"],
                        value
                    ];
                    value = styles.filter(s => s != null).join(";");
                    settings["style"] = value;
                } else {
                    settings[attribute.name] = value;
                }
            }
        }

        var resolvedSettings = { ...gobiDefaultSettings, ...settings };
        for (const property in resolvedSettings) {
            this.setAttribute(property, resolvedSettings[property]);
        }
        if (discover) {
            gobi.discover();
        }
    }
}
customElements.define('gobi-stories-container', GobiStoriesContainer);